import classNames from 'classnames';
import React from 'react';
import _ from 'underscore';
import Config from 'js/config';
import PropTypes from 'prop-types';
import createReactClass from 'create-react-class';

const Alert = createReactClass({
  propTypes: {
    children: PropTypes.any,
    className: PropTypes.string,
    global: PropTypes.bool,
    noClose: PropTypes.bool,
    onFinished: PropTypes.func,
    style: PropTypes.object,
    timeout: PropTypes.number,
    type: PropTypes.oneOf(['danger', 'info', 'success', 'warning', 'cta']),
  },

  getDefaultProps() {
    return {
      global: false,
      noClose: false,
      timeout: Config.ux.alertTimeout, // Setting a timeout of false or -1 will force the user to have to dismiss it (at least till another alert comes along)
      type: 'danger',
    };
  },

  getInitialState() {
    return {
      display: true,
    };
  },

  componentDidMount() {
    this.runTimeout();
  },

  componentWillReceiveProps() {
    // Reset the alert
    this.setState({
      display: true,
    });
    clearTimeout(this.timeout);
    this.runTimeout();
  },

  componentWillUnmount() {
    clearTimeout(this.timeout);
  },

  close() {
    if (this.props.onFinished) {
      this.props.onFinished();
    } else {
      this.setState({
        display: false,
      });
      window.app.setAlert(null);
    }
  },

  runTimeout() {
    if (!!this.props.timeout && this.props.timeout >= 0) {
      this.timeout = setTimeout(this.close, this.props.timeout);
    }
  },

  onMouseEnter() {
    clearTimeout(this.timeout);
  },

  onMouseLeave() {
    this.runTimeout();
  },

  render() {
    const {
      type,
      className,
      children,
      global,
      noClose,
      style,
    } = this.props;

    const classes = {
      alert: true,
      'site-alert': global,
    };

    if (type) {
      classes['alert-' + type] = true;
    }

    const styleRoot = _.extend({}, {
      display: this.state.display ? 'block' : 'none',
    },
    style
    );

    return <div onMouseEnter={this.onMouseEnter} onMouseLeave={this.onMouseLeave}
      className={classNames(className, classes)} style={styleRoot}>
      <div className="alert-container">
        {!noClose ? <button type="button" className="alert-close icon-close" onClick={this.close}><span className="sr-only" /></button> : null}
        {children}
      </div>
    </div>;
  },
});

module.exports = Alert;



// WEBPACK FOOTER //
// ./app/assets/jsx/lib/alert.jsx